import type { LazyLoading } from './MediaGallery.config.ts';
import type { MediaGalleryItem } from './MediaGallery.tsx';

export function getCurrentMediaItemByIndex(
  items: MediaGalleryItem[],
  index: number
): MediaGalleryItem | undefined {
  return index in items ? items[index] : undefined;
}

export function hasPrev(
  items: MediaGalleryItem[],
  index: number,
  wrapAround?: boolean
): boolean {
  if (!items || items.length <= 1) return false;
  if (wrapAround) return true;
  return index > 0;
}

export function hasNext(
  items: MediaGalleryItem[],
  index: number,
  wrapAround?: boolean
): boolean {
  if (!items || items.length <= 1) return false;
  if (wrapAround) return true;
  return index < items.length - 1;
}

/** Set lazy loading for images AFTER the threshold index */
export function getImageLazyLoadingProp(
  lazyLoadingConfig: LazyLoading,
  currentIndex: number,
  thresholdIndex: number
): 'lazy' | undefined {
  if (lazyLoadingConfig === 'auto' && currentIndex > thresholdIndex) {
    return 'lazy';
  }
  return undefined;
}

export function getNextNavigatableItemAndIndex(
  items: MediaGalleryItem[],
  currentIndex: number,
  direction: 1 | -1
) {
  let newIndex = currentIndex + direction;
  // go to the last or first slide if we are on the first or last slide
  if (newIndex < 0) {
    newIndex = items.length - 1;
  } else if (newIndex >= items.length) {
    newIndex = 0;
  }
  const newItem = getCurrentMediaItemByIndex(items, newIndex);
  return {
    newIndex,
    newItem
  };
}
